import * as React from "react"
import { Navigate } from "react-router-dom"

import {STOCK_ROUTES, USER_ROLES} from "@constants"
import AppLayout from "Layout"
import StockChangesPage from "./Changes"
import StockSharePage from "./Share"
import StockAssortmentDetailsPage from "./AssDetails";
import {userData} from "../../@signals";


export const StockRoutes = {
    path: STOCK_ROUTES.PATH,
    title: STOCK_ROUTES.TITLE,
    accessKey: STOCK_ROUTES.ACCESS_KEY,
    icon: 'cubes-stacked',
    element: <AppLayout />,
    description: "Monitoring and Analysis of Product Inventory Levels",
    children: [{
        element: <Navigate to={STOCK_ROUTES.STOCK_ASSORT_PATH} replace />, index: true
    }, {
        title: STOCK_ROUTES.STOCK_ASSORT_TITLE,
        path: STOCK_ROUTES.STOCK_ASSORT_PATH,
        dashboardKey: STOCK_ROUTES.STOCK_ASSORT_ID,
        access: USER_ROLES.STANDARD,
        element: <StockAssortmentDetailsPage />
    }, {
        title: STOCK_ROUTES.STOCK_AFFINITY_TITLE,
        path: STOCK_ROUTES.STOCK_ASSORT_PATH,
        dashboardKey: STOCK_ROUTES.STOCK_ASSORT_ID,
        access: USER_ROLES.RETAILER,
        element: <StockAssortmentDetailsPage />
    }, {
        title: STOCK_ROUTES.STOCK_CHANGES_TITLE,
        path: STOCK_ROUTES.STOCK_CHANGES_PATH,
        dashboardKey: STOCK_ROUTES.STOCK_CHANGES_ID,
        element: <StockChangesPage />
    }, {
        title: STOCK_ROUTES.STOCK_SHARE_TITLE,
        path: STOCK_ROUTES.STOCK_SHARE_PATH,
        dashboardKey: STOCK_ROUTES.STOCK_SHARE_ID,
        element: <StockSharePage />
    }]
}